module.exports = __webpack_public_path__ + "svg/dice-dark-blue.svg?6f71bd8181ca1ceabf9c994d1b514a74";